import { useEffect, useState, useMemo } from "react";
import MapView from "../components/MapView";
import ChartPanel from "../components/ChartPanel";
import { io } from "socket.io-client";
import { authFetch } from "../api";

const API = "https://tradeon.fi/api";

export default function Admin() {

  const [devices,setDevices] = useState([]);
  const [history,setHistory] = useState([]);
  const [selected,setSelected] = useState(null);
  const [showGraph,setShowGraph] = useState(false);
  const [search,setSearch] = useState("");

  // =====================================================
  // LOAD DEVICES ONCE
  // =====================================================
  useEffect(()=>{

    const load = async ()=>{
      try{
        const data = await authFetch(`${API}/devices`);
        setDevices(data || []);
      }catch(e){
        console.log("devices load error");
        setDevices([]);
      }
    };

    load();

  },[]);

  // =====================================================
  // HISTORY
  // =====================================================
  useEffect(()=>{

    if(!selected) return;

    const id = selected.imei || selected.id;
    if(!id) return;

    const load = async ()=>{
      try{
        const data = await authFetch(`${API}/history/${id}`);
        setHistory(data || []);
      }catch{
        setHistory([]);
      }
    };

    load();

  },[selected]);

  // =====================================================
  // SOCKET REALTIME
  // =====================================================
  useEffect(()=>{

    const socket = io("https://tradeon.fi",{
      path:"/socket.io/",
      transports:["websocket"],
      auth:{
        token: localStorage.getItem("accessToken")
      }
    });

    socket.on("connect",()=>{
      console.log("SOCKET CONNECTED");
    });

    socket.on("temp",(d)=>{

      // 🔥 UPDATE EXISTING DEVICE ONLY
      setDevices(prev=>{
        return prev.map(dev=>{
          if((dev.imei||dev.id) !== d.imei) return dev;

          return {
            ...dev,
            temp: d.temp ?? dev.temp,
            water: d.water ?? dev.water,
            lat: d.lat ?? dev.lat,
            lng: d.lon ?? dev.lng
          };
        });
      });

      // 🔥 UPDATE GRAPH ONLY IF SELECTED
      setHistory(prev=>{
        if(!selected) return prev;
        if((selected.imei||selected.id) !== d.imei) return prev;
        return [...prev,{time:d.time,temp:d.temp}].slice(-300);
      });

    });

    return ()=>socket.disconnect();

  },[selected]);

  // =====================================================
  // FILTER
  // =====================================================
  const filteredDevices = useMemo(()=>{
    return devices.filter(d=>{
      const name = (d.name||d.imei||"").toLowerCase();
      return name.includes(search.toLowerCase());
    });
  },[devices,search]);

  const handleSelect = (d)=>{
    setSelected(d);
  };
  
  
  //=======================GRAHP =========================

  // =====================================================
  // UI
  // =====================================================
  return (
    <div style={{display:"flex",height:"100vh",background:"#000"}}>

      {/* SIDEBAR */}
      <div style={{
        width:260,
        background:"#050505",
        borderRight:"1px solid #111",
        padding:15,
        display:"flex",
        flexDirection:"column"
      }}>

        <input
          placeholder="Search..."
          value={search}
          onChange={e=>setSearch(e.target.value)}
          style={{
            marginBottom:15,
            padding:8,
            borderRadius:8,
            background:"#111",
            color:"#00e5ff",
            border:"1px solid #222"
          }}
        />

        <div style={{overflowY:"auto",flex:1}}>
          {filteredDevices.map(d=>(
            <div
              key={d.imei||d.id}
              onClick={()=>handleSelect(d)}
              style={{
                padding:12,
                marginBottom:10,
                borderRadius:12,
                cursor:"pointer",
                background:
                  selected && (selected.imei||selected.id)===(d.imei||d.id)
                  ? "rgba(0,229,255,.25)"
                  : "rgba(0,229,255,.08)",
                color:"#00e5ff"
              }}
            >
              <b>{d.name||d.imei}</b>
              {typeof d.temp==="number" && <div>🌡 {d.temp.toFixed(1)}°C</div>}
              {typeof d.water==="number" && <div>💧 {d.water.toFixed(1)}</div>}
            </div>
          ))}
        </div>
      </div>

      {/* MAP */}
  <div style={{flex:1,position:"relative", zIndex: 0}}>

  <MapView
    devices={devices}
    selected={selected}
    setSelected={handleSelect}
  />

  {selected && (
  <div style={{
    position:"absolute",
    top:20,
    left:"50%",
    transform:"translateX(-50%)",
    padding:"12px 24px",
    borderRadius:40,
    background:"rgba(0,0,0,.6)",
    color:"#00e5ff",
    display:"flex",
    gap:15,
    zIndex: 10000   // 🔥 suurempi kuin graph
  }}>
    <b>{selected.name||selected.imei}</b>
    {typeof selected.temp==="number" && <span>🌡 {selected.temp.toFixed(1)}°C</span>}
    {typeof selected.water==="number" && <span>💧 {selected.water.toFixed(1)}</span>}
    <button onClick={()=>setShowGraph(v=>!v)}>
      {showGraph ? "hide" : "graph"}
    </button>
  </div>
)}

</div>
      )}

     {selected && showGraph && (
  <div
    style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      height: 260,
      background: "#000",
      zIndex: 9999
    }}
  >
    <ChartPanel history={history} />
  </div>
)}
      )}

    </div>
  );
}
